import { render, staticRenderFns } from "./NormalSearchNav328.vue?vue&type=template&id=2822dc82&scoped=true&"
import script from "./NormalSearchNav328.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav328.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2822dc82",
  null
  
)

export default component.exports